import { create } from "zustand"
import { persist } from "zustand/middleware"

interface TimerState {
  // Local elapsed tracking (seconds) — updated by setInterval in TimerIndicator
  elapsedSeconds: number
  setElapsedSeconds: (seconds: number) => void

  // Whether the timer entry form should open after stopping
  showEntryFormAfterStop: boolean
  setShowEntryFormAfterStop: (show: boolean) => void

  // Stopped timer data (populated after stop, consumed by TimeEntryForm)
  stoppedTimerData: {
    matter: string
    description: string
    category: string
    template: string
    durationMinutes: number
  } | null
  setStoppedTimerData: (data: TimerState["stoppedTimerData"]) => void

  // Timer start dialog
  timerStartDialogOpen: boolean
  setTimerStartDialogOpen: (open: boolean) => void
}

export const useTimerStore = create<TimerState>()(
  persist(
    (set) => ({
      elapsedSeconds: 0,
      setElapsedSeconds: (seconds) => set({ elapsedSeconds: seconds }),

      showEntryFormAfterStop: true,
      setShowEntryFormAfterStop: (show) => set({ showEntryFormAfterStop: show }),

      stoppedTimerData: null,
      setStoppedTimerData: (data) => set({ stoppedTimerData: data }),

      timerStartDialogOpen: false,
      setTimerStartDialogOpen: (open) => set({ timerStartDialogOpen: open }),
    }),
    {
      name: "timer-storage",
      partialize: (state) => ({
        showEntryFormAfterStop: state.showEntryFormAfterStop,
      }),
    }
  )
)
